import { PackageMeta } from '../PackageMeta';
import { z } from 'zod';

// TODO: refactor this
export const GetSourceItemBranchResponse = z.object({
  id: z.string(),
  meta: z.object({
    label: z.string(),
    mocks: z.any(),
  }),
  createdBy: z
    .object({
      id: z.any(),
      accountId: z.string(),
      userId: z.string(),
      createdAt: z.date().or(z.string()),
    })
    .optional(),
  published: z
    .object({
      version: z.string(),
    })
    .optional(),
  latestRevisionId: z.string().optional(),
  packageMeta: PackageMeta,
  revision: z.array(
    z.object({
      id: z.string(),
      accountId: z.string().optional(),
      userId: z.string().optional(),
      createdAt: z.date().or(z.string()).optional(),
    }),
  ),
});

export const GetSourceItemResponse = z.object({
  id: z.string().optional(),
  createdAt: z.date().or(z.string()),
  meta: z
    .object({
      shared: z.object({
        currentAccount: z.boolean(),
      }),
      label: z.string(),
    })
    .optional(),
  createdBy: z
    .object({
      id: z.any(),
      accountId: z.string(),
      userId: z.string(),
      createdAt: z.date().or(z.string()),
    })
    .optional(),
  source: z.array(GetSourceItemBranchResponse),
});

// TODO: refactor this
export const GetSourcesResponse = z.object({
  total: z.number(),
  hits: z.array(GetSourceItemResponse),
});

// TODO: refactor this
export const GetSourceRevisionResponse = z.object({
  data: z.any().or(
    z.object({
      helpTextSource: z.string().trim().optional(),
      hooksSource: z.string().trim().optional(),
      invalidData: z.any().optional(),
      logicSource: z.string().trim().optional(),
      migrationSource: z.string().trim().optional(),
      rootInputSettings: z.any().optional(),
      rootInputUrn: z.string().trim().optional(),
      // TODO: use packageMeta instead
      stepDetails: z.any().optional().describe('Deprecated'),
      stepPackages: z.any().optional(),
    }),
  ),
  published: z
    .object({
      version: z.string(),
    })
    .optional(),
  sandboxUploaded: z.boolean().optional(), // TODO: remove this after frontend will be updated #SA-32
  playgroundUploaded: z.boolean().optional(),
  sourceMeta: z
    .any()
    .or(
      z.object({
        meta: z
          .any()
          .or(
            z.object({
              label: z.string().trim().nonempty().optional(),
              mocks: z.any().optional(),
            }),
          )
          .optional(),
        revision: z
          .any()
          .or(
            z.object({
              accountId: z.string().trim().optional(),
              createdAt: z.date().or(z.string()).optional(),
              id: z.string().trim().optional(),
              userId: z.string().trim().optional(),
            }),
          )
          .optional(),
      }),
    )
    .optional()
    .describe('branch and revision meta data'),
});

export const ForkSourceBranchResponse = z.object({
  id: z.string(),
  revisionId: z.string(),
  sourceId: z.string(),
  packageUpdateResult: z.any().optional(),
});
